<template>
  <div>
    <!-- Sidebar solo para gestores -->
    <SidebarMantenimientoGestor v-if="isAuthorized" />

    <v-snackbar v-model="sessionExpired" color="error" :timeout="2000" top>
      La sesión ha caducado. Por favor, inicia sesión de nuevo.
    </v-snackbar>

    <!-- Contenido principal -->

    <v-container fluid>
      <router-view />
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import SidebarMantenimientoGestor from '@/components/utils/mantenimiento/SidebarMantenimientoGestor.vue'
import { jwtDecode } from 'jwt-decode';

export default {
  name: 'LayoutMantenimiento',

  // Registro de componentes necesarios en Vue 2
  components: {
    SidebarMantenimientoGestor
  },
  computed:{
    ...mapState(["permisos"]),
    isAuthorized(){
      return this.permisos.includes('administrar-preventivos');
    }
  },
  data() {
    return {
      sessionExpired: false,
      cliente_seleccionado: null
    }
  },
  mounted(){
    this.cliente_seleccionado = localStorage.getItem("clienteSeleccionado");
    this.setClientId(jwtDecode(localStorage.getItem("token")).id_cliente);

    this.redirigirAInicio();
  },
  beforeDestroy() {
    this.setClientId(this.cliente_seleccionado);
  },
  methods:{
    ...mapActions(["setClientId"]),
    redirigirAInicio() {
      /**
       * Solo redirigimos si el usuario está en la ruta raíz del mantenimiento "/mantenimiento"
       * Esto evita que si el usuario refresca estando en "Plantillas", se le mande al inicio por error.
       */
      if (this.$route.path === '/mantenimiento' || this.$route.path === '/mantenimiento/') {
        const targetName = this.isAuthorized ? 'mantenimiento-admin' : 'mantenimiento-operario';
        
        // Evitamos error de navegación duplicada
        if (this.$route.name !== targetName) {
          this.$router.push({ name: targetName }).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              console.error(err);
            }
          });
        }
      }
    }
  }
}
</script>

<style scoped>
/* 
  Si usas Vuetify 2, v-main ya gestiona automáticamente los offsets del layout.
  Si necesitas forzarlo, puedes descomentar lo siguiente:
  */

.v-main {
  padding-left: 0 !important;
  padding-top: 0 !important;
}
</style>